import React from "react";
import ArtistSection from "../ArtistSection";
import ScrollContainer from "react-indiana-drag-scroll";

function KeySubtopicModule({ KeySubtopicsThroughout }) {
  return (
    <div className="h-auto w-full p-6">
      <h1 className="text-left text-2xl font-bold text-black">
        Key Subtopics Throughout
      </h1>

      <ScrollContainer
        vertical={true}
        className="scrollbar-none grid h-[500px] grid-cols-1 items-start gap-6 overflow-y-scroll rounded-2xl px-4 py-16 shadow-socialglass [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      >
        {KeySubtopicsThroughout.map((subtopic, id) => (
          <ArtistSection
            id={id}
            name={subtopic.name}
            submissions={subtopic.timesSubmitted}
            description={subtopic.subHeading}
            avatarColor="bg-gradient-to-br from-orange-400 to-purple-500"
          />
        ))}
      </ScrollContainer>
    </div>
  );
}

export default KeySubtopicModule;
